import { ApiResponse } from '../utils/types';

export const checkVisaRequirements = async (passport: string, destination: string): Promise<ApiResponse> => {
  const response = await fetch('/api/check-visa', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ passport, destination }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || 'Unable to retrieve visa requirements. Please try again.');
  }

  return response.json();
};
